import { FC } from 'react'
import s from './GigAssHeader.module.sass'
import { IconReset } from '../../ui/IconReset'
import { GigAssClose } from '../GigAssClose'
import { useAppSelector } from '@app/model/store'

interface GigAssHeaderProps {
  isRotating: boolean
  onReload: () => void
  onClose: () => void
}

/**
 * @function GigAssHeader - шапка чата
 */
const GigAssHeader: FC<GigAssHeaderProps> = (props) => {
  const hasMessages = useAppSelector((store) => !!store.gigAssist.messages?.length)
  const { isRotating, onReload, onClose } = props

  return (
    <header className={s.header} data-visible={hasMessages}>
      <div className={s.gradient}></div>
      <button className={`${s.buttonReload} ${isRotating ? s.rotating : ''}`} onClick={onReload}>
        <IconReset />
        <span>Сбросить чат</span>
      </button>

      <GigAssClose onClick={onClose} />
    </header>
  )
}

export default GigAssHeader
